import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { GetService, PostService } from "../../../../Services/ConstantService";
import { API_URL } from "../../../../Services/ApiService";
import {
  showErrorAlert,
  showSuccessAlert,
} from "../../../../Helper/SweetAlert";
import { MoonLoader } from "react-spinners";

export default function CompanyDetails() {
  const [phone, setphone] = useState("");
  const [email, setemail] = useState("");
  const [timing, settiming] = useState("");
  const [address, setaddress] = useState("");
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);
  const [submitLoader, setsubmitLoader] = useState(false);


  function submit() {
    if (!phone || !email || !timing || !address) {
      setError(true);
      return;
    }
    const data = { phone, email, timing, address, id:1 };

    setsubmitLoader(true);
    PostService(API_URL.UPDATE_COMPANY_INFO, data).then(
      (res) => {
        if (res.data.status === true) {
          setsubmitLoader(false)
          getUserDetails()
          showSuccessAlert(res?.data?.message, getUserDetails);
        } else {
          showErrorAlert(res.data?.message);
        }
      },
      (err) => {
        showErrorAlert(err.data?.message);
      }
    );
  }

  useEffect(() => {
    getUserDetails();
  }, []);

  const getUserDetails = async () => {
    // setLoading(true)
    GetService(API_URL.GET_COMPANY_INFO).then((res) => {
      if (res.data?.status === true) {
        setphone(res.data?.data?.phone);
        setemail(res.data?.data?.email);
        settiming(res.data?.data?.timing);
        setaddress(res.data?.data?.address);
        setLoading(false);
      } else {
        showErrorAlert(res.data?.message);
        setLoading(false);
      }
    });
  };

  return (
    <div>
      <section className="content-header">
        <div className="container-fluid">
          <div className="row mb-2">
            <div className="col-sm-6">
              <h3>Company Details</h3>
            </div>
            <div className="col-sm-6">
              <ol className="breadcrumb float-sm-right">
                <Link
                  to="/panel/dashboard"
                  className="breadcrumb-item"
                  style={{ textDecoration: "none" }}
                >
                  Dashboard
                </Link>
                <Link className="breadcrumb-item active">Company Details</Link>
              </ol>
            </div>
          </div>
        </div>
      </section>
      <div class="card">
        {!loading && (
          <div class="card-body mt-3">
            {/* <h4 class="card-title">Add Company Details</h4> */}
            <div className="row offset-md-1">
              <div className="col-md-5 col-12 form-group">
                <label>Email Id</label>
                <input
                  type="Email"
                  placeholder="Enter Email"
                  className="form-control"
                  value={email}
                  onChange={(e) => setemail(e?.target?.value)}
                />
                 {error && !email && (
                        <div className="error mt-1">Email is required</div>
                      )}
              </div>
              <div className="col-md-5 col-12 form-group">
                <label>Phone Number</label>
                <input
                  type="text"
                  placeholder="Enter Phone Number"
                  className="form-control"
                  value={phone}
                  onChange={(e) => setphone(e?.target?.value)}
                />
                 {error && !phone && (
                        <div className="error mt-1">phone number is required</div>
                      )}
              </div>
            </div>
            <div className="row offset-md-1">
              <div className="col-md-5 col-12 form-group">
                <label>Timing</label>
                <input
                  type="text"
                  placeholder="Enter Timing"
                  className="form-control"
                  value={timing}
                  onChange={(e) => settiming(e?.target?.value)}
                />
                 {error && !timing && (
                        <div className="error mt-1">Timing is required</div>
                      )}
              </div>
              <div className="col-md-5 col-12 form-group">
                <label>Address</label>
                <input
                  type="text"
                  placeholder="Enter Address"
                  className="form-control"
                  value={address}
                  onChange={(e) => setaddress(e?.target?.value)}
                />
                 {error && !address && (
                        <div className="error mt-1">address is required</div>
                      )}
              </div>
            </div>
            <div>
              <div className="offset-md-1">
                <button
                  className="btn btn-primary ml-3"
                  onClick={() => submit()}
                >
                   {submitLoader ? (
                    <i className="fas fa-spinner fa-spin"></i>
                  ) : (
                    "Submit"
                  )}
                 
                </button>
              </div>
            </div>
          </div>
        )}
        {loading ? (
          <div className="LoaderSpinner">
            <MoonLoader
                          color={"#003bff"}
                          loading={loading}
                          speedMultiplier={0.6}
                          size={50}
                        />
            <div>Loading... Please wait.</div>
          </div>
        ) : (
          ""
        )}
      </div>
    </div>
  );
}
